import { groupBy } from 'lodash';
import {
	updateDomainDropdownSelection,
	updateIntentDropdownSelection,
	updateSubCategoriesDropdownList,
	updateSubCategoriesDropdownSelection
} from "../../utilities/applicationState";
import getDevPortalContext from "../../utilities/devPortalContext";


export const intentDataList = [
	{
		label: "Read or Write",
		value: ["Read Data", "Write Data"]
	},
	{
		label: "Subscribe to events",
		value: ["Subscribe to events"]
	}
];

export const defaultIntentSelection = (isApiContext) => {
	return (isApiContext ? intentDataList[0] : intentDataList[1]);
}

export const getAllDomains = (domainData = []) => domainData.map(({ label, value }) => ({ label, value}));
export const getAllSubCategories = (selectedDomains = [], domainData = []) => {
	return selectedDomains.map(({ value }) => domainData.find(item => item.value === value))
		.reduce((acc, item) => [...acc, ...item.subCategories], []);
};


export const setDropdownDefaults = (dispatch, domainData = [], isApiContext) => {
	// set dropdowns search defaults: list & selections
	const allDomains = getAllDomains(domainData);
	dispatch(updateIntentDropdownSelection(defaultIntentSelection(isApiContext)));
	handleDomainSelections(allDomains, dispatch, domainData);
	dispatch(updateSubCategoriesDropdownSelection(getAllSubCategories(allDomains, domainData)));
};

export const clearDropdownSelections = (dispatch) => {
	dispatch(updateIntentDropdownSelection(null));
	dispatch(updateDomainDropdownSelection([]));
	dispatch(updateSubCategoriesDropdownSelection([]));
}

export const handleDomainSelections = (selections = [], dispatch, domainData = [], subCategoriesSelections = []) => {
	dispatch(updateDomainDropdownSelection(selections));

	if (selections.length === 0) {
		dispatch(updateSubCategoriesDropdownList([]));
		dispatch(updateSubCategoriesDropdownSelection([]));

		return;
	}

		const subCategoryItems = [];

		// loop over selections given by the component and add their subcategories to the list
		selections.map(({ value }) => domainData.find(item => item.value === value)).forEach((item) => {
			subCategoryItems.push({ group: item.label, items: item.subCategories })
		});

		dispatch(updateSubCategoriesDropdownList(subCategoryItems));

		// //  check if any existing subcategories selections are not in the new set of subcategories
		if (subCategoriesSelections.length > 0) {
			const updatedSelections = subCategoriesSelections.filter((selected) => {
				return subCategoryItems.some((item) => {
					if (item.group) {
						// the item is a group, check it's items property
						return item.items.some((groupItem) => groupItem.value === selected.value);
					}
					// it's a normal non-grouped item
					return item.value === selected.value
				});
			});
			
			dispatch(updateSubCategoriesDropdownSelection(updatedSelections));
		}
};

export const handleSubCategoriesSelections = (selections = [], dispatch) => {
	dispatch(updateSubCategoriesDropdownSelection(selections));
}


export const dontShowWizard = async (reqBody) => {
	const { data } = await getDevPortalContext().post(`${import.meta.env.VITE_API_V2_PATH}/do-not-show-page-filter`, reqBody)
	return data;
};

// wizard guide & search page use same app state for list data and selections
export const searchOptions = (
ShouldSkip = false,
selectedIntentData = null,
selectedDomainData = [],
selectedSubCategoryData = [],
filteredApis = [],
pageNumber = 1,
itemsPerPage = 50,
selectedIncludeCheckBoxValues,
searchStr,
isApiContext,
subscribedEvents) => {

	const selections = [];
	const domainMap = {};
	let intent = '';

	const includeValues = selectedIncludeCheckBoxValues.map((includeObj) => {
		return includeObj.value
	});

	if (ShouldSkip) {
		isApiContext ? intent = "Read Data" : intent = "Subscribe to events";

	} else {

		if (!selectedIntentData) {
			isApiContext ? intent = "Read Data" : intent = "Subscribe to events";
		} else {
			intent = selectedIntentData.value
		}

		// loop all subcategories selections (has domain linked together in object)
		selectedSubCategoryData.forEach((subCategory) => {
			const subCategoriesList = domainMap[subCategory.domain] || [];
			subCategoriesList.push(subCategory.value);

			domainMap[subCategory.domain] = subCategoriesList;
		});

		Object.keys(domainMap).forEach((key) => {
			selections.push({
				domain: key,
				subCategories: domainMap[key]
			});
		});
	}

	const postData = {
		intent,
		selections,
		pageNumber,
		itemsPerPage
	};

	if (searchStr) {
		postData.search = searchStr;
	}
	if (intent === 'Subscribe to events' || (Array.isArray(intent) && intent.includes('Subscribe to events'))) {
		postData.subscribedEvents = subscribedEvents.reduce((acc, sub) => {
			acc.push({
				code: sub.code,
				canonicalUri: sub.canonicalUri
			})
			return acc;
		}, []);
	} else {
		postData.includeApis = includeValues;
		postData.operations = filteredApis.reduce((acc, api) => {
			acc.push({
				httpMethod: api.verb,
				uri: api.path,
				canonicalUri: api.canonical
			})
			return acc
		}, []);
	}

	return postData;
};

export const searchRequest = async (postData, productCode) => {
	const { data } = await getDevPortalContext().post(`${import.meta.env.VITE_API_V2_PATH}/${productCode}/search`, postData);

	return data;
};

export const groupSearchResults = (list) => {
	const groupResults = groupBy(list, (item) => {
		const domain = item.domain;
		const subCategory = item.subCategory;
		return `${domain};${subCategory}`
	})

	return Object.keys(groupResults).sort().map(domainSubCategoryKey=> {
		return {
			header: domainSubCategoryKey,
			list: groupResults[domainSubCategoryKey]
		};
	});
};